/**
 * Zdroje návštěv (aktivace). Používá se v mapa_access_log.source a v adminu
 * Doporučení, aby bylo vidět, zda uživatel přišel z aplikace, chatu nebo e-mailu.
 */
export const VISIT_SOURCES = ["app", "chat", "email", "referral"] as const;
export type VisitSource = (typeof VISIT_SOURCES)[number];

const STORAGE_KEY = "cz_visit_source";

export function isVisitSource(v: unknown): v is VisitSource {
  return typeof v === "string" && (VISIT_SOURCES as readonly string[]).includes(v);
}

/** Normalizuje ?src= / ?utm_source= na jeden ze známých zdrojů. */
export function normalizeVisitSource(raw: string | null | undefined): VisitSource {
  const v = (raw ?? "").trim().toLowerCase();
  if (!v) return "app";
  if (isVisitSource(v)) return v;
  if (v.includes("mail") || v === "newsletter" || v === "invite") return "email";
  if (v.includes("chat") || v === "messenger" || v === "whatsapp" || v === "telegram") return "chat";
  if (v === "ref" || v.includes("referr")) return "referral";
  return "app";
}

/**
 * Zjistí zdroj aktuální návštěvy z URL a zapamatuje si ho pro celou relaci,
 * aby se stejný zdroj propsal i do pozdějších akcí (registrace, mapa).
 */
export function currentVisitSource(): VisitSource {
  if (typeof window === "undefined") return "app";
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get("src") ?? params.get("utm_source");
    if (fromUrl) {
      const s = normalizeVisitSource(fromUrl);
      window.sessionStorage.setItem(STORAGE_KEY, s);
      return s;
    }
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (isVisitSource(stored)) return stored;
  } catch {
    /* ignore */
  }
  return "app";
}
